import { render, staticRenderFns } from "./FeaturesTable.vue?vue&type=template&id=ae08ca5c&scoped=true"
import script from "./FeaturesTable.vue?vue&type=script&lang=js"
export * from "./FeaturesTable.vue?vue&type=script&lang=js"
import style0 from "./FeaturesTable.vue?vue&type=style&index=0&id=ae08ca5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae08ca5c",
  null
  
)

export default component.exports